








import Vue from "vue";

export default Vue.extend({
  name: "Footer",
  computed: {
    mascotSrc(): string {
      switch (this.$route.path) {
        case "/game-projects":
          return "img/projects/Guy2.gif";
        case "/resume":
          return "img/projects/Guy3.gif";
        case "/contact":
          return "img/projects/Guy5.gif";
        default:
          return "img/projects/Guy2.gif";
      }
    }
  }
});
